import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbQrcodeService } from './service/cmdb-qrcode.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cmdb-qrcode',
	templateUrl: './cmdb-qrcode.component.html',
	styleUrls: ['./cmdb-qrcode.component.scss'],
})
export class CmdbQrcodeComponent implements OnInit, AfterViewInit {
	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
		lbl_rep_custom_arquivo_nao_encontrado: 'Archive not found',
		lbl_geral_identificacao: 'Identification',
		lbl_geral_tipo: 'Type',
		lbl_kb_mais_info: 'Show more info',
		lbl_clique_logar_e_ver_mais_informacoes: 'Click here to log-in and see more information',
	};

	constructor(
		private ActivatedRoute: ActivatedRoute,
		private LabelsService: LabelsService,
		private CmdbQrcodeService: CmdbQrcodeService,
		private AuthLoginService: AuthLoginService,
		private Router: Router,
		private CryptoService: CryptoService
	) {}

	isLoggedIn: boolean;
	qrValue = '';
	qrColorLight = '';
	qrColorDark = '';

	ciBasicData: ciInterface['ciArray'][number];

	isLoadingLabels = true;
	isLoadingQrCode = true;

	//TagId, Id, SerialNumber
	allowedSearchParams = ['ti', 'id', 'sn'];

	ngOnInit(): void {
		this.isLoggedIn = this.AuthLoginService.isLoggedIn();

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.ActivatedRoute.params.subscribe((parameters) => {
			if (
				parameters.searchParam &&
				this.allowedSearchParams &&
				this.allowedSearchParams.includes(parameters.searchParam.slice(0, 2))
			) {
				this.CmdbQrcodeService.getCiBasicData(parameters.searchParam).subscribe(
					(ciData) => {
						this.ciBasicData = ciData;
						this.qrValue = location.href;
						this.isLoadingQrCode = false;
					},
					() => {
						this.isLoadingQrCode = false;
					}
				);
			} else {
				this.isLoadingQrCode = false;
			}
		});
	}

	ngAfterViewInit(): void {
		this.qrColorLight = document.querySelectorAll('html')[0].style.getPropertyValue('--body-bg');
		this.qrColorDark = document.querySelectorAll('html')[0].style.getPropertyValue('--body-color');
	}

	openCmdb(): void {
		window.open(`/cmdb/${this.ciBasicData.idCiType}/${this.ciBasicData.id}`, '_blank');
	}

	openLogin(): void {
		const goTo = this.CryptoService.encryptB64(`/cmdb/${this.ciBasicData.idCiType}/${this.ciBasicData.id}`);
		this.Router.navigateByUrl(`/login?gt=${goTo}`);
	}
}
